/*
export const someAction = (state) => {}
 */

import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { createQueryString, serializeObject } from 'src/utils'
const moment = require('moment')

export default {
  add,
  addNew,
  select,
  selectInstructorUser,
  submitInstructorForApproval,
  exportExcel,
  fetch,
  fetchAutoComplete,
  fetchManagerAutoComplete,
  fetchAffiliateAutoComplete,
  fetchInstructorClasses,
  fetchUserDetails,
  fetchInstructors,
  fetchAffiliates,
  fetchRecruiters,
  fetchAffiliateManagers,
  addManagerAffiliate,
  removeManagerFromAffiliate,
  fetchManagers,
  fetchAdministrators,
  create,
  createUser,
  createManager,
  createRecruiter,
  createAffiliate,
  createInstructor,
  update,
  remove,
  clearAllForms,
  getSelectedUserPermissions,
  submitRoleForm,
  migrateInstructor,  
  retrieveCustomerPaymentMethods,
  deleteCustomerPaymentProfile
}

async function addNew({ commit, dispatch, state }) {
  commit('doneSaving')
  dispatch('clearAllForms')
  commit('users/openUserModal', { mode: 'add' }, { root: true })
}

async function add({ commit, dispatch, state }) {
  let vm = this._vm
  console.log("commit", commit);
  const response = await dispatch('create')
  console.log("resp: ", response);
  if (response && response.success) {
    dispatch('clearAllForms')
    commit('users/closeDetails', {}, { root: true })
    vm.$root.$emit('refreshGrid:userListGrid')
  } else {
    commit('doneSaving')
    commit('doneLoading')
  }
  return response
}

async function retrieveCustomerPaymentMethods ({ commit }, { USER_ID }) {
  try {
    commit('users/setLoadingPaymentProfiles', true, { root: true })
    const { data: response } = await api.post('/payments/getCustomerPaymentProfiles', { USER_ID })
    const { success, payload } = response
    if (!success) throw response
    commit('users/setCustomerPaymentProfiles', payload.customerProfiles, { root: true })
    commit('users/setLoadingPaymentProfiles', false, { root: true })
    return response
  } catch (response) {
    commit('users/setLoadingPaymentProfiles', false, { root: true })
    return response
  }
}

async function deleteCustomerPaymentProfile ({ commit }, { customerProfileId, customerPaymentProfileId, cascadesProfileId }) {
  try {
    commit('users/setLoadingPaymentProfiles', true, { root: true })
    const { data: response } = await api.post('/payments/removeCustomerPaymentMethod', { customerProfileId, customerPaymentProfileId, cascadesProfileId })
    const { success } = response
    if (!success) throw response
    commit('users/setLoadingPaymentProfiles', false, { root: true })
    return response
  } catch (response) {
    commit('users/setLoadingPaymentProfiles', false, { root: true })
    return response
  }
}

async function migrateInstructor({commit, state}){
  try{
    commit('setMigratingInstructor',true)
    let USER_ID = state.selectedUser.USER_ID
    let INSTRUCTOR_ID = state.selectedMigrateInsturctor
    let { data } = await api.post('user/migrateInstructor',{ INSTRUCTOR_ID, USER_ID })
    let { success, message } = data
    notify.respond(data)
    commit('setMigratingInstructor',false)
    if(success) commit('setMigrateOpen',false)
  }
  catch(err){
    commit('setMigratingInstructor',true)

    console.log(err)
  }
}

async function select({ commit, dispatch, state }, payload) {
  commit('doneSaving')

  let vm = payload.vm || null
  let selectedUser = payload.selectedUser || payload

  if (vm) {
    vm.$q.loading.show({
      message: "Loading User"
    })
  }
  try{
    dispatch('clearAllForms')
    let response = await api.post('/user/one/', { id: selectedUser.USER_ID })
    
    if(!response.data.success){
      notify.create({message:response.data.message, type: "negative"})
      if (vm) vm.$q.loading.hide()
    }

    const user = response.data.payload.user
    let addresses = response.data.payload.userAddresses
    if (addresses && addresses.length > 0) {
      let billingAddress = _.filter(addresses, function (addr) {
        return addr.LK_ADDRESS_TYPE_ID === 3
      })
      let shippingAddress = _.filter(addresses, function (addr) {
        return addr.LK_ADDRESS_TYPE_ID === 4
      })
      if (billingAddress.length > 0) {
        commit('setBillingAddressForm', { billingAddress: billingAddress[0].ADDRESS })
        billingAddress = billingAddress[0].ADDRESS
      }
      if (shippingAddress.length > 0) {
        commit('setShippingAddressForm', { shippingAddress: shippingAddress[0].ADDRESS })
        shippingAddress = shippingAddress[0].ADDRESS
      }
      let sameAsBilling = (shippingAddress && shippingAddress.ADDRESS_ID === billingAddress.ADDRESS_ID)
      commit('setSameAsBilling', { status: sameAsBilling, initialLoad: true })
    }

    const { INSTRUCTOR, AFFILIATE, RECRUITER, MANAGER, ADMINISTRATOR, NOTIFICATION_SETTINGS } = user

    user.USER_DOB = user.USER_DOB ? moment(user.USER_DOB).format('L') : ''
    commit('setSelectedUser', { user })
    commit('setInstructorForm', INSTRUCTOR)
    commit('setAffiliateForm', AFFILIATE)
    commit('setRecruiterForm', RECRUITER)
    commit('setManagerForm', MANAGER)
    commit('setAdministratorForm', ADMINISTRATOR)
    commit('setNotificationSettings', NOTIFICATION_SETTINGS)

    commit('setUserForm', { user })
    commit('users/openUserModal', { mode: 'edit' }, { root: true })
    commit('setManagersForAffiliate', [])   
    if (vm) vm.$q.loading.hide()

    return Promise.resolve()
  }
  catch(err){
    if (vm) vm.$q.loading.hide()
    notify.create({
      message: "Error loading user.",
      type: "negative"
    })
  }
}

async function selectInstructorUser({ commit, dispatch, state }, instructor) {
  try {
    const { data: response } = await api.post('/user/selectInstructor/', instructor)
    const { success, payload } = response
    if (!success) throw response

    const approvalHistory = payload.approvals
    commit('setActiveApproval', { instructor, approvalHistory })

    const user = payload.user
    const INSTRUCTOR = payload.instructor
    
    if (user) {
      user.USER_DOB = user.USER_DOB ? moment(user.USER_DOB).format('L') : ''
    }

    commit('setSelectedUser', { user })

    let addresses = payload.userAddresses
    if (addresses && addresses.length > 0) {
      let billingAddress = _.filter(addresses, function (addr) {
        return addr.LK_ADDRESS_TYPE_ID === 3
      })
      let shippingAddress = _.filter(addresses, function (addr) {
        return addr.LK_ADDRESS_TYPE_ID === 4
      })

      if (billingAddress.length > 0) {
        commit('setBillingAddressForm', { billingAddress: billingAddress[0].ADDRESS })
        billingAddress = billingAddress[0].ADDRESS
      }
      if (shippingAddress.length > 0) {
        commit('setShippingAddressForm', { shippingAddress: shippingAddress[0].ADDRESS })
        shippingAddress = shippingAddress[0].ADDRESS
      }

      let sameAsBilling = (shippingAddress && shippingAddress.ADDRESS_ID === billingAddress.ADDRESS_ID)
      commit('setSameAsBilling', { status: sameAsBilling, initialLoad: true })
    }
    const { AFFILIATE, RECRUITER, MANAGER, ADMINISTRATOR, NOTIFICATION_SETTINGS } = user

    commit('setInstructorForm', INSTRUCTOR)
    commit('setAffiliateForm', AFFILIATE)
    commit('setRecruiterForm', RECRUITER)
    commit('setManagerForm', MANAGER)
    commit('setAdministratorForm', ADMINISTRATOR)
    commit('setNotificationSettings', NOTIFICATION_SETTINGS)
    
    commit('setUserForm', { user })
    commit('users/openUserModal', { mode: 'approve' }, { root: true })
    return response
  } catch (response) {
    commit('doneLoading')
    notify.respond(response)
  }
}

async function submitInstructorForApproval({ commit, state }, {vm, id, notes, status}) {
  try {
    const response = await api.post(`/approvals/submitInstructor`, { id, notes, status })
    const { success, message } = response.data
    
    if (!success) throw response

    commit('approvals/clearRejectionNotes', {}, { root: true })
    commit('users/closeDetails', {}, { root: true })

    notify.create({ message, type: "positive" })
    vm.$root.$emit('refreshGrid:instructorApprovalsGrid')

    return response
  } catch (response) {
    commit('users/closeDetails', {}, { root: true })
    //notify.create({ message })
    notify.respond(response)
  }
}

async function exportExcel({ commit, state }, { pagination, filter, columns }) {
  const exportExcel = true
  try {
    const query = createQueryString({ pagination, filter, columns, exportExcel })
    const { data: response } = await api.get('/user/fetch' + query)

    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response

    return response
  } catch (response) {
    return response
  }
}

async function fetch({ commit, state }, { pagination, filter, columns, exportOptions }) {
  commit('isLoading')
  try {
    let query = createQueryString({ pagination, filter, columns, exportOptions })

    let fieldQuery
    if (state.searchType) {
      const searchFields = state.searchFields[state.searchType]
      let finalSearchFields = _.pickBy(searchFields, v => {
        return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
      })
      if (!_.isEmpty(finalSearchFields)) {
        fieldQuery = serializeObject({ searchType: state.searchType, searchFields: { ...finalSearchFields } })
      }
      else {
        fieldQuery = serializeObject({ searchType: state.searchType })
      }
    }
    if (state.searchType) {
      commit('activeSearchType', state.searchType)
    }
    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')
    const { data: response } = await api.get('/user/fetch' + finalQuery)

    const { success, payload } = response

    commit('doneLoading')
    if (!success) throw response

    if (!exportOptions) commit('setList', { users: payload.users })
    return response
  } catch (response) {
    commit('doneLoading')
    notify.respond(response)
    return response
  }
}

async function fetchInstructorClasses({ commit, state }, { pagination, filter, columns }) {
  commit('loadingUserClasses', true)

  try {
    const customFilter = [{ "field": "USER_ID", "filter": state.selectedUser.USER_ID }]
    let query = createQueryString({ pagination, filter, columns, customFilter })
    const { data: response } = await api.post('/calendar/instructor' + query)
    const { success, payload } = response
    commit('loadingUserClasses', false)
    commit('setInstructorClassList', { classes: payload.classes })
    return response
  } catch (response) {
    commit('loadingUserClasses', false)
    notify.respond(response)
  }
}

async function fetchUserDetails({ commit, state }) {

}

async function fetchInstructors({ commit, state }) {
  // commit('isLoading')
  try {
    // const query = createQueryString({ pagination, filter, columns })
    // console.log('query', query)
    const { data: response } = await api.get('/instructor/fetch')
    const { success, payload } = response
    // commit('doneLoading')
    if (!success) throw response

    commit('setInstructorList', { instructors: payload })
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function fetchAffiliateManagers({ commit, state }, { pagination, filter, columns }) {
  commit('loadingAffiliateManagers', true)
  try {
    const query = createQueryString({ pagination, filter, columns })
    const { data: response } = await api.post('/user/affiliateManagers' + query, { AFFILIATE_ID: state.affiliateForm.AFFILIATE_ID })
    const { success, payload } = response

    if (!success) throw response
    
    commit('setManagersForAffiliate', payload)    
    commit('loadingAffiliateManagers', false)
    return response
  }
  catch (response) {
    commit('loadingAffiliateManagers', false)
    notify.respond(response)
  }
}

async function addManagerAffiliate({ commit, state }, payload){
  let vm = payload
  try{
    state.addingManagerToAffiliate = true
    
    let { data } = await api.post('/user/addManagerToAffiliate',{ 
        AFFILIATE_ID: state.affiliateForm.AFFILIATE_ID,
        MANAGER_ID: state.currentManagerAffiliateManager.item.MANAGER_ID
      }) 
      
    const { success, message } = data

    console.log(message)
    if(success){
      commit('updateManagerAffiliateModalOpen', false)
      state.addingManagerToAffiliate = false
      notify.create({message: message, type: "positive"})
      vm.$root.$emit('refreshGrid:managerAffiliate')
    }
    else throw message
  }
  catch(err){
    state.addingManagerToAffiliate = false
    console.log(err)
    notify.create({message: err, type: "negative"})
  }
}

async function removeManagerFromAffiliate({ commit, state }, payload){
  let vm = payload
  try{
    let managerIds = state.selectedAffiliateManagers.map(x => x.MANAGER_ID)
    let { data } = await api.post('/user/removeManagerFromAffiliate', managerIds) 
      
    const { success, message } = data

    if(success){
      notify.create({message: message, type: "positive"})
      vm.$root.$emit('refreshGrid:managerAffiliate')
      commit('updateSelectedAffiliateManagers', [])
    }
    else throw message
  }
  catch(err){
    notify.create({message: err, type: "negative"})
  }
}

async function fetchManagersAffiliate({ commit, state }, { pagination, filter, columns }) {
  commit('loadingAffiliateManagers', true)
  try {
    const query = createQueryString({ pagination, filter, columns })
    const { data: response } = await api.post('/user/managerAffiliates' + query, { AFFILIATE_ID: state.affiliateForm.AFFILIATE_ID })
    const { success, payload } = response

    if (!success) throw response
    
    commit('setManagersForAffiliate', payload)    
    commit('loadingAffiliateManagers', false)
    return response
  }
  catch (response) {
    commit('loadingAffiliateManagers', false)
    notify.respond(response)
  }
}

async function fetchAffiliates({ commit, state }) {
  // commit('isLoading')
  try {
    // const query = createQueryString({ pagination, filter, columns })
    // console.log('query', query)
    const { data: response } = await api.get('/affiliate/fetch')

    const { success, payload } = response
    // commit('doneLoading')
    if (!success) throw response

    commit('setAffiliateList', { affiliates: payload })
    return response
  } catch (response) {
    // commit('doneLoading')
    notify.respond(response)
  }
}

async function fetchRecruiters({ commit, state }) {
  // commit('isLoading')
  try {
    // const query = createQueryString({ pagination, filter, columns })
    // console.log('query', query)
    const { data: response } = await api.get('/recruiter/fetch')

    const { success, payload } = response
    // commit('doneLoading')
    if (!success) throw response

    commit('setRecruiterList', { recruiters: payload })
    return response
  } catch (response) {
    // commit('doneLoading')
    notify.respond(response)
  }
}

async function fetchManagers({ commit, state }) {
  // commit('isLoading')
  try {
    // const query = createQueryString({ pagination, filter, columns })
    // console.log('query', query)
    const { data: response } = await api.get('/manager/fetch')

    const { success, payload } = response
    // commit('doneLoading')
    if (!success) throw response

    commit('setManagerList', { managers: payload })
    return response
  } catch (response) {
    // commit('doneLoading')
    notify.respond(response)
  }
}

async function fetchAdministrators({ commit, state }) {
  // commit('isLoading')
  try {
    // const query = createQueryString({ pagination, filter, columns })
    // console.log('query', query)
    const { data: response } = await api.get('/administrator/fetch')

    const { success, payload } = response
    // commit('doneLoading')
    if (!success) throw response

    commit('setAdministratorList', { administrators: payload })
    return response
  } catch (response) {
    // commit('doneLoading')
    notify.respond(response)
  }
}

async function create({ commit, dispatch, state }) {
  let vm = this._vm
  commit('doneSaving')
  const { userForm, billingAddressForm, shippingAddressForm, instructorForm, affiliateForm, recruiterForm, managerForm, administratorForm, notificationSettings, managerCourses } = state
  //serForm.USER_DOB = new Date(userForm.USER_DOB).toUTCString()
  const form = {
    userForm,
    billingAddressForm,
    shippingAddressForm,
    instructorForm,
    affiliateForm,
    recruiterForm,
    managerForm,
    managerCourses,
    administratorForm,
    notificationSettings
  }
  try {
    const { data: response } = await api.post('/user/create', { form })
    const { success, payload } = response
    if (!success) throw response

    commit('updateUserForm', { field: 'USER_ID', value: payload.USER_ID })
    commit('updateBillingAddressForm', { field: 'ADDRESS_ID', value: payload.BILLING_ADDRESS_ID })
    commit('updateShippingAddressForm', { field: 'ADDRESS_ID', value: payload.SHIPPING_ADDRESS_ID })
    dispatch('fetch', {})
    // commit('closeDetails', {}, { root: true })
    notify.respond(response)
    vm.$root.$emit('refreshGrid:userListGrid')
    return response
  }
  catch (response) {
    notify.respond(response)
  }
  commit('doneSaving')
}

async function update ({ commit, dispatch, state }, { vm }) {
  commit('isSaving')
  let approvalMode = state.userModal.mode == 'approve'
  const { userForm, billingAddressForm, shippingAddressForm, instructorForm, affiliateForm, recruiterForm, managerForm, administratorForm, notificationSettings } = state
  console.log('userForm', userForm);
  //userForm.USER_DOB = new Date(userForm.USER_DOB).toISOString()
  const form = {
    userForm,
    billingAddressForm,
    shippingAddressForm,
    instructorForm,
    affiliateForm,
    recruiterForm,
    managerForm,
    administratorForm,
    notificationSettings
  }
  try {
    const { data: response } = await api.post('/user/update', { form })
    console.log('form', form);
    const { success } = response
    commit('doneSaving')
    if (!success) throw response

    if(!approvalMode) dispatch('fetch', {})
    commit('doneSaving')
    if(!approvalMode) commit('users/closeDetails', {}, { root: true })
    
    notify.respond(response)
    setTimeout(function () {
      if (vm && approvalMode) vm.$root.$emit('refreshGrid:instructorApprovalsGrid')
    })
    return response
  } catch (response) {
    console.log(response)
    notify.respond(response)
  }
}

async function remove ({ commit, dispatch, state }) {
  const { userForm, billingAddressForm, shippingAddressForm } = state
  const { USER_ID } = userForm
  const { BILLING_ADDRESS_ID } = billingAddressForm
  const { SHIPPING_ADDRESS_ID } = shippingAddressForm

  try {
    const { data: response } = await api.post('/user/remove', { USER_ID, BILLING_ADDRESS_ID, SHIPPING_ADDRESS_ID })
    const { success } = response
    if (!success) throw response

    dispatch('fetch', {})
    commit('users/closeDetails', {}, { root: true })
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function createUser({ commit, state }) {
  const { userForm, billingAddressForm, shippingAddressForm } = state
  try {
    const { data: response } = await api.post('/user/createNewUser', { userForm, billingAddressForm, shippingAddressForm })
    const { success, payload } = response
    commit('updateUserForm', { field: 'USER_ID', value: payload.USER_ID })

    if (!success) throw response
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
  }
}

// async function updateUser({ commit, state }) {
//   const { userForm, billingAddressForm, shippingAddressForm } = state
//   try {
//     const { data: response } = await api.post('/user/updateUser', { userForm, billingAddressForm, shippingAddressForm })
//     const { success, payload } = response
//     commit('updateUserForm', { field: 'USER_ID', value: payload.USER_ID })

//     if (!success) throw response
//     notify.respond(response)
//     return response
//   } catch (response) {
//     notify.respond(response)
//   }
// }

async function createManager({ commit, state, dispatch, rootState }) {
  const courses = state.managerCourses
  // const USER_ID = state.userForm.USER_ID 
  const USER_ID = state.userForm.USER_ID
  try {
    const { data: response } = await api.post('/user/createManagerRole', { USER_ID })
    const { success } = response
    if (!success) throw response
    return response
  } catch (response) {
    notify.respond(response)
  }
  // return response
  // commit('updateManagerForm', { field: 'MANAGER_ID', value: response.})

  // await courses.map(course => {
  //   const courseManager = { MANAGER, COURSE_ID: course }
  //   return dispatch('courses/createCourseManager', { courseManager })
  // })

  // commit('users/closeDetails', {}, { root: true })
  // notify.respond(response)
  // return response
}

async function createRecruiter({ commit, state, dispatch, rootState }) {
  const USER_ID = state.userForm.USER_ID
  const recruiterForm = state.recruiterForm
  recruiterForm.USER_ID = USER_ID
  try {
    const { data: response } = await api.post('/user/createRecruiterRole', { recruiterForm })
    const { success } = response
    if (!success) throw response
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function createAffiliate({ commit, state, dispatch, rootState }) {
  const USER_ID = state.userForm.USER_ID
  const affiliateForm = state.affiliateForm
  affiliateForm.USER_ID = USER_ID
  try {
    const { data: response } = await api.post('/user/createAffiliateRole', { affiliateForm })
    const { success } = response
    if (!success) throw response
    console.log('affiliate response', response)
    commit('updateAffiliateForm', { field: 'AFFILIATE_ID', value: response.payload.AFFILIATE_ID })
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function createInstructor({ commit, state, dispatch, rootState }) {
  const USER_ID = state.userForm.USER_ID
  const instructorForm = state.instructorForm
  instructorForm.USER_ID = USER_ID
  try {
    const { data: response } = await api.post('/user/createInstructorRole', { instructorForm })
    const { success } = response
    if (!success) throw response
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function associateAffiliatesByCourse({ commit, state }) {
  const USER_ID = state.userForm.USER_ID
  const instructorForm = state.instructorForm
  instructorForm.USER_ID = USER_ID
  try {
    const { data: response } = await api.post('/user/associateAffiliatesByCourse', { instructorForm })
    const { success } = response
    if (!success) throw response
    return response
  } catch (response) {
    notify.respond(response)
  }
}

function clearAllForms({ commit, state }) {
  commit('clearUserForm')
  commit('clearBillingAddressForm')
  commit('clearShippingAddressForm')
  commit('clearInstructorForm')
  commit('clearRecruiterForm')
  commit('clearAffiliateForm')
  commit('clearManagerForm')
  commit('clearAdministratorForm')
  commit('auth/clearChangePasswordForm',{}, {root:true})
  //commit('clearActiveApproval')
}

// async function addUser ({ commit, state }) {
//   commit('clearUserForm')
//   commit('clearAddressForm')
//   commit('openDetails', { module, mode: 'add' }, { root: true })
// }

function submitRoleForm({ commit, state }, payload) {
  console.log('submitting role form')
}

async function getSelectedUserPermissions({ commit, state }) {
}

async function fetchAutoComplete({ commit, dispatch, state }, { s }) {
  try {
    const { data: response } = await api.post('/user/autocomplete', { s })
    commit('setAutoCompleteList', { users: response.payload })
  } catch (err) {

  }
}

async function fetchManagerAutoComplete({ commit, dispatch, state }, { s }) {
  try {
    const { data: response } = await api.post('/user/managerAutocomplete', { s })
    commit('setManagerAutoCompleteList', { managers: response.payload })
    return response.payload
  } catch (err) {

  }
}

async function fetchAffiliateAutoComplete({ commit, dispatch, state }, { s }) {
  try {
    const { data: response } = await api.post('/user/affiliateAutocomplete', { s })
    commit('setAffiliateAutoCompleteList', { affiliates: response.payload })
    return response.payload
  } catch (err) {

  }
}


/******************************************************************

                      Private Functions

*******************************************************************/

// function selectRoleForm ({ role, studentForm, instructorForm, recruiterForm, affiliateForm, managerForm, administratorForm }) {
//   if (role === 'student') return studentForm
//   if (role === 'instructor') return instructorForm
//   if (role === 'recruiter') return recruiterForm
//   if (role === 'affiliate') return affiliateForm
//   if (role === 'manager') return managerForm
//   if (role === 'administrator') return administratorForm
// }
